module.exports = __webpack_public_path__ + "img/7.004dbfc5.png";